import Vue from 'vue';
import Router from 'vue-router';
import Begin from '@/components/Begin';
import Deel1 from '@/components/Deel1';
import Deel2 from '@/components/Deel2';
import Deel3 from '@/components/Deel3';
import Deel4 from '@/components/Deel4';

Vue.use(Router);

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Begin',
      component: Begin
    },
    {
      path: '/deel/1',
      name: 'Deel1',
      component: Deel1
    },
    {
      path: '/deel/2',
      name: 'Deel2',
      component: Deel2
    },
    {
      path: '/deel/3',
      name: 'Deel3',
      component: Deel3
    },
    {
      path: '/deel/4',
      name: 'Deel4',
      component: Deel4
    },
  ]
});
